<script lang="ts">
	import Button, { Label } from '@smui/button';
	import Tab, { Icon } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import { _ } from 'svelte-i18n';
	import IndirizzoDipendente from '../../../../../../shared/models/Dipendente/IndirizzoDipendente';
	import FiltroGenerico from '../../../../../../shared/models/Filtri/FiltroGenerico';
	import QueryIndirizzoDipendenteList from './QueryIndirizzoDipendente/QueryIndirizzoDipendenteList.svelte';
	import QueryIndirizzoDipendenteMap from './QueryIndirizzoDipendente/QueryIndirizzoDipendenteMap.svelte';
	import QueryQuestionarioSediReportList from './QueryQuestionarioSediReport/QueryQuestionarioSediReportList.svelte';

	window.localStorage.removeItem('sediRispondentiId');
	window.localStorage.removeItem('questionariSediReportId');

	export let data;
	export let sediSelected;

	let filtersIndirizziDipendenti: FiltroGenerico = {
		sediId: [],
		pagina: 1,
		elementiPerPagina: 10,
	};

	let filtersQuestionariSediReport: FiltroGenerico = {
		descrizione: '',
		daApprovareAziendaEnte: false,
		areaId: null,
		setQuestionarioId: null,
		pagina: 1,
		elementiPerPagina: 10,
	};

    $: {
		filtersIndirizziDipendenti = {
			...filtersIndirizziDipendenti,
			sediId: sediSelected?.map(sede => sede.id),
		};

		filtersQuestionariSediReport = {
			...filtersQuestionariSediReport,
			sediId: sediSelected?.map(sede => sede.id),
		};
	}
	
    let tabs = [
        {
            icon: 'person_pin_circle',
            label: 'Indirizzario dipendenti',
        },
        {
            icon: 'poll',
            label: 'Questionari',
        }
    ];

    let active = tabs[0];

	let indirizziDipendentiTableVisualization = true;

	$: if (!indirizziDipendentiTableVisualization) {
		filtersIndirizziDipendenti = {
			...filtersIndirizziDipendenti,
			indirizzoOK: true,
			pagina: undefined,
			elementiPerPagina: undefined
		};
	} else {
		if (filtersIndirizziDipendenti.indirizzoOK === true) {
			filtersIndirizziDipendenti = {
				...filtersIndirizziDipendenti,
				indirizzoOK: undefined,
				pagina: 1,
				elementiPerPagina: 10,
			};
		}
	}

    $: [dataIndirizziDipendenti, loadingIndirizziDipendenti, errorIndirizziDipendenti] = IndirizzoDipendente.getList(filtersIndirizziDipendenti);
</script>

<div class="pt-1">
	<TabBar {tabs} let:tab bind:active>
		<Tab {tab} minWidth>
			<Icon class="material-icons">{tab.icon}</Icon>
			<Label>{tab.label}</Label>
		</Tab>
	</TabBar>

	{#if active.label === 'Indirizzario dipendenti'}
		<div class="flex w-full">
            <div class="flex-grow">
                <Button
                    on:click="{() => {
                        indirizziDipendentiTableVisualization = !indirizziDipendentiTableVisualization;
                    }}"
                    type="button"
                    variant="raised"
                    class="mt-3.5 w-max p-2.5 text-base"
                >
                    <Label class="text-sm">{indirizziDipendentiTableVisualization ? 'Visualizza elenco su mappa' : 'Visualizza elenco su tabella'}</Label>
                </Button>
            </div>

            <div class="flex justify-end">
                <button title="{$_('page.employee.list.export')}" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{() => IndirizzoDipendente.export(filtersIndirizziDipendenti)}">
                    <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">file_download</span>
                </button>
            </div>
        </div>
		{#if indirizziDipendentiTableVisualization}
			<QueryIndirizzoDipendenteList dataList={[dataIndirizziDipendenti, loadingIndirizziDipendenti, errorIndirizziDipendenti ]} bind:filters={filtersIndirizziDipendenti}/>
		{:else}
			{#if !$loadingIndirizziDipendenti}
				<QueryIndirizzoDipendenteMap dataAziendeEnti={data} dataIndirizziDipendenti={dataIndirizziDipendenti}/>
			{/if}
		{/if}
	{:else if active.label = "Questionari"}
		<QueryQuestionarioSediReportList  bind:filters={filtersQuestionariSediReport}/>
	{/if}
</div>